module.exports = __webpack_public_path__ + "static/media/copy.74a7371e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/help/copy.gif
// module id = 426
// module chunks = 0